module.exports = __webpack_public_path__ + "img/AM_Banner_Fathers-Day-2022.295fc77a.jpg";